import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-754c33d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  type: "button",
  class: "bbtn payment-btn"
}
const _hoisted_2 = { class: "icons-container" }
const _hoisted_3 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentButton',
  props: {
    icons: null
  },
  setup(__props: any) {

    //props
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.icons, (pmIcon) => {
        return (_openBlock(), _createElementBlock("img", {
          key: pmIcon,
          src: pmIcon
        }, null, 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})